var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.style)},[(_vm.expired)?_c('span',{staticClass:"red--text"},[_vm._v("! "+_vm._s(_vm.value)+" ")]):_c('span',[_vm._v(" "+_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }